import { Component, OnInit, NgZone, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SidebarService } from '../../services/sidebar.service';
import { GlobalService } from '../../services/global.service';
import { BasicQuestionComponent } from '../../shared/modal/basic-question/basic-question.component';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormControl, FormGroup, Validators, ValidatorFn} from '@angular/forms';
import 'rxjs/add/operator/filter';
import Utils from '../../shared/utility';
import * as cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'app-sidebar-client-edit',
  templateUrl: './sidebar-client-edit.component.html',
  styleUrls: ['./sidebar-client-edit.component.css']
})
export class SidebarClientEditComponent implements OnInit {
  @Input() profile: any;
  @Input() section: any;
  @Input() isClient: any;
  @Output() delete: EventEmitter<any> = new EventEmitter();


  public screenVisible: Boolean;
  public selectedClient: any;
  public selectedClientSpouse: any;
  public error: string;

  public userType: number;
  public visible: boolean;
  public isTopGA: boolean;

  isClientVisible: boolean;
  showMobile: boolean = false;
  showMenu: boolean = false;

  myInnerHeight: string;
  slideOutTrayVisible: boolean = false;
  isOnlySocialSecurity: boolean = false;

  profileInfo: FormGroup;
  healthInfo: FormGroup;
  incomeInfo: FormGroup;
  retireInfo: FormGroup;
  additionalQuesInfo: FormGroup;
  retirementHealthcare: FormGroup;

  selectedRetirementAge: Number;
  editedClient: any;
  calculateLifeExpectancy: Number;
  spouseCalculateLifeExpectancy: Number;
  profileOrg: any;
  isPre65: boolean;

  constructor(public sidebarService: SidebarService, private router: Router, private ngZone: NgZone, private globalService: GlobalService, private matDialog: MatDialog) {
    // This sidebar status should only occur when on a report page (viewing, editing, creating)
    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
    this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));

    this.isOnlySocialSecurity = globalService.featSocialSecurity && !globalService.featMeansTesting && !globalService.featLongTermCare && !globalService.featHealthCare && !globalService.featCombinedHealthcareLTC;

    //console.log(window.screen.height);
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe(event => this.handleSidebarStatus((event as NavigationEnd).url));

    window.onresize = () => { // Detect screen size and resizing
      ngZone.run(() => {
        if (window.innerWidth < 900 && this.screenVisible) {
          this.screenVisible = false;
        } else if (window.innerWidth >= 900 && !this.screenVisible) {
          this.screenVisible = true;
        }
      })
    }
  }

  public allStates: any[] = Utils.allStates;
  //selectedStatus:  number ;  
  //selectedClientSpouse; //JSON.parse(this.profile.client.clientProfile.Spouses);

  ngOnInit() {
    this.screenVisible = window.innerWidth < 900 ? false : true;
    this.userType = Number(localStorage.getItem('roleId')) || 3;
    
    //TODO: all of these forms are built off of a client - need to make this work for spouse too...
    //console.log('Editing Section: ', this.section);
    console.log('profile passed: ', this.profile);
    this.profileOrg = cloneDeep(this.profile);
    this.profileOrg.clientProfile.Spouses =  JSON.parse(this.profileOrg.clientProfile.Spouses);
    //console.log('isClient passed: ', this.isClient);
    this.selectedClientSpouse = JSON.parse(this.profile.clientProfile.Spouses);
    // if(!this.isClient){
    //   this.selectedClientSpouse = JSON.parse(this.profile.clientProfile.Spouses);
    // }

    //need to get brackets to display for client
    this.getMMTBracket();

    //need to setup metro regions if LTC questionnaire filled out
    //if(this.profile.clientProfile.ClientMetroArea && this.isClient || this.profile.clientProfile.SpouseMetroArea && !this.isClient){
    //this.getLTCStateRegions((this.isClient) ? this.profile.clientProfile.RetirementState : this.selectedClientSpouse[0].state, (this.isClient) ? this.profile.clientProfile.ClientMetroArea : this.profile.clientProfile.SpouseMetroArea);
    this.getLTCStateRegions((this.isClient) ? this.profile.clientProfile.RetirementState : this.selectedClientSpouse[0].state);
    //}

    const youngerThanValidator = (minAge: number, maxAge: number): ValidatorFn => control =>
    //cant be older than max
    (this.globalService.calculateAgeV2(control.value)) > maxAge 
    //cant be younger than min
    || (this.globalService.calculateAgeV2(control.value)) < minAge   
      ? {invalidDate: 'Please make sure age is between ' + minAge + ' and ' + maxAge + '.' }  
      : null;

    this.profileInfo = new FormGroup({
      firstName: new FormControl(((this.isClient) ? this.profile.client.FirstName : this.selectedClientSpouse[0].firstName), [Validators.required, Validators.minLength(2), Validators.maxLength(24), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      lastName: new FormControl((this.isClient) ? this.profile.client.LastName : this.selectedClientSpouse[0].lastName, [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
      gender: new FormControl((this.isClient) ? this.profile.client.GenderID : this.selectedClientSpouse[0].gender, [Validators.required]),
      dob: new FormControl(new Date((this.isClient) ? this.profile.client.DOB : this.selectedClientSpouse[0].dob), [Validators.required, youngerThanValidator(18, 80)]),
      runReportWithSpouse: new FormControl(this.profile.clientProfile.IsRunReportWithSpouse ? this.profile.clientProfile.IsRunReportWithSpouse: false),
      isLegalSpouse: new FormControl(this.selectedClientSpouse[0].isLegalSpouse == '1' ? 1: 0),
      maritalStatus: new FormControl()
    });

    this.healthInfo = new FormGroup({
      highBP: new FormControl((((this.isClient) ? this.profile.clientProfile.HCHBP : this.selectedClientSpouse[0].HCHBP) > 0) ? true : false),
      highChol: new FormControl((((this.isClient) ? this.profile.clientProfile.HCHC : this.selectedClientSpouse[0].HCHC) > 0) ? true : false),

      obesity: new FormControl((((this.isClient) ? this.profile.clientProfile.HCOBS : this.selectedClientSpouse[0].HCOBS) > 0) ? true : false),
      ptsd: new FormControl((((this.isClient) ? this.profile.clientProfile.HCPTSD : this.selectedClientSpouse[0].HCPTSD) > 0) ? true : false),
      alzheimers: new FormControl((((this.isClient) ? this.profile.clientProfile.HCALZ : this.selectedClientSpouse[0].HCALZ) > 0) ? true : false),
      parkinsons: new FormControl((((this.isClient) ? this.profile.clientProfile.HCPARK : this.selectedClientSpouse[0].HCPARK) > 0) ? true : false),
      amputation: new FormControl((((this.isClient) ? this.profile.clientProfile.HCAMP : this.selectedClientSpouse[0].HCAMP) > 0) ? true : false),
  
      type1Diab: new FormControl((((this.isClient) ? this.profile.clientProfile.HCT1D : this.selectedClientSpouse[0].HCT1D) > 0) ? true : false),
      type2Diab: new FormControl((((this.isClient) ? this.profile.clientProfile.HCT2D : this.selectedClientSpouse[0].HCT2D) > 0) ? true : false),
      cardioDisease: new FormControl((((this.isClient) ? this.profile.clientProfile.HCCD : this.selectedClientSpouse[0].HCCD) > 0) ? true : false),
      cardioDiseaseYearsDiagnosed: new FormControl((((this.isClient) ? this.profile.clientProfile.HCCDYrsDiag : this.selectedClientSpouse[0].HCCDYrsDiag) > 0) ? true : false),
      cancer: new FormControl((((this.isClient) ? this.profile.clientProfile.HCC : this.selectedClientSpouse[0].HCC) > 0) ? true : false),
      cancerYearsDiagnosed: new FormControl((((this.isClient) ? this.profile.clientProfile.HCCYrsDiag : this.selectedClientSpouse[0].HCCYrsDiag) > 0) ? true : false),
      multSclerosis: new FormControl((((this.isClient) ? this.profile.clientProfile.HCMS : this.selectedClientSpouse[0].HCMS) > 0) ? true : false),
      tobacco: new FormControl((((this.isClient) ? this.profile.clientProfile.HCT : this.selectedClientSpouse[0].HCT) > 0) ? true : false),
      depCaneWalker: new FormControl((((this.isClient) ? this.profile.clientProfile.HCDCW : this.selectedClientSpouse[0].HCDCW) > 0) ? true : false),
      famHistory: new FormControl((((this.isClient) ? this.profile.clientProfile.HCFHDC : this.selectedClientSpouse[0].HCFHDC) > 0) ? true : false),
      lifeExp: new FormControl((this.isClient) ? this.profile.clientProfile.LifeExpectancy : this.selectedClientSpouse[0].LifeExpectancy, [Validators.required])
    });

    this.incomeInfo = new FormGroup({
      incomeOption: new FormControl((this.profile.clientProfile.Bracket != null) ? 1 : 2),
      incomeBracket: new FormControl((this.profile.clientProfile.Bracket != null) ? this.profile.clientProfile.Bracket : '')
    });

    this.retireInfo = new FormGroup({
      retirementAge: new FormControl((this.isClient) ? this.profile.clientProfile.RetirementAge : parseInt(this.selectedClientSpouse[0].retirementAge), [Validators.required]),      
      retirementState: new FormControl((this.isClient) ? this.profile.clientProfile.RetirementState : this.selectedClientSpouse[0].state, [Validators.required]),      
      retirementStateMetroArea: new FormControl((this.isClient) ? this.profile.clientProfile.ClientMetroArea : this.profile.clientProfile.SpouseMetroArea)
    });
    console.log('this.profile.clientProfile.SpousePremiums', this.profile.clientProfile.SpousePremiums);
    console.log('this.isClient)', this.isClient);
    console.log('this.client', this.profile.clientProfile)
    // console.log('this.profile.clientProfile.Premiums', this.profile.clientProfile.Premiums.MedicarePartB);

    this.retirementHealthcare = new FormGroup({
      needPrivateInsurance: new FormControl((this.isClient) ? (this.profile.clientProfile.IsPrivHealthIns) ? 'true' : 'false' : (this.profile.clientProfile.IsSpousePrivHealthIns) ? 'true' : 'false'),
      coverageType: new FormControl((this.isClient) ? (this.profile.clientProfile.CoverageType ?  this.profile.clientProfile.CoverageType : "HMO"): (this.profile.clientProfile.SpouseCoverageType ? this.profile.clientProfile.SpouseCoverageType : "HMO")),
      premiumType: new FormControl((this.isClient) ? this.profile.clientProfile.PremiumType : this.profile.clientProfile.SpousePremiumType),

      // medAdvantageHMO:  new FormControl((this.profile.clientProfile.PremiumType == 'HMO') ? ((this.isClient) ? this.profile.clientProfile.Premiums.MedicareAdvantageHMO : this.profile.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO) : ''),
      // medAdvantagePPO:  new FormControl((this.profile.clientProfile.PremiumType == 'PPO') ? ((this.isClient) ? this.profile.clientProfile.Premiums.MedicareAdvantagePPO : this.profile.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO) : ''),
      // premMedPartB: new FormControl((this.profile.clientProfile.PremiumType == 'TM') ? ((this.isClient) ? this.profile.clientProfile.Premiums.MedicarePartB : this.profile.clientProfile.SpousePremiums.SpouseMedicarePartB) : ''),
      // premMedPartD: new FormControl((this.profile.clientProfile.PremiumType == 'TM') ? ((this.isClient) ? this.profile.clientProfile.Premiums.MedicarePartD : this.profile.clientProfile.SpousePremiums.SpouseMedicarePartD) : ''),
      // premSupplemental: new FormControl((this.profile.clientProfile.PremiumType == 'TM') ? ((this.isClient) ? this.profile.clientProfile.Premiums.SupplimentalInsurance : this.profile.clientProfile.SpousePremiums.SpouseSupplimentalInsurance) : ''),
      // premDental: new FormControl((this.profile.clientProfile.Premiums) ? this.profile.clientProfile.Premiums.DentalInsurance : ''), //always avail


      
      medAdvantageHMO:   new FormControl((this.isClient) ? (this.profile.clientProfile.PremiumType == 'HMO') ? this.profile.clientProfile.Premiums.MedicareAdvantageHMO  : '' : (this.profile.clientProfile.SpousePremiumType == 'HMO') ? this.profile.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO : ''),
      medAdvantagePPO:  new FormControl((this.isClient) ? (this.profile.clientProfile.PremiumType == 'PPO') ? this.profile.clientProfile.Premiums.MedicareAdvantagePPO  : '' : (this.profile.clientProfile.SpousePremiumType == 'PPO') ? this.profile.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO : ''),
      premMedPartB: new FormControl((this.isClient) ? (this.profile.clientProfile.PremiumType == 'TM') ? this.profile.clientProfile.Premiums.MedicarePartB  : '' : (this.profile.clientProfile.SpousePremiumType == 'TM') ? this.profile.clientProfile.SpousePremiums.SpouseMedicarePartB : ''),
      premMedPartD: new FormControl((this.isClient) ? (this.profile.clientProfile.PremiumType == 'TM') ? this.profile.clientProfile.Premiums.MedicarePartD  : '' : (this.profile.clientProfile.SpousePremiumType == 'TM') ? this.profile.clientProfile.SpousePremiums.SpouseMedicarePartD : ''),
      premSupplemental: new FormControl((this.isClient) ? (this.profile.clientProfile.PremiumType == 'TM') ? this.profile.clientProfile.Premiums.SupplimentalInsurance  : '' : (this.profile.clientProfile.SpousePremiumType == 'TM') ? this.profile.clientProfile.SpousePremiums.SpouseSupplimentalInsurance : ''),
      premSupplementalPlanType: new FormControl((this.isClient) ? this.profile.clientProfile.SelfSupplementalPlan : this.profile.clientProfile.SpouseSupplementalPlan),
      premDental: new FormControl((this.profile.clientProfile.Premiums && this.isClient) ? this.profile.clientProfile.Premiums.DentalInsurance : ((this.profile.clientProfile.SpousePremiums) ? this.profile.clientProfile.SpousePremiums.SpouseDentalInsurance : '')), //always avail

      oopHospDocsTests: new FormControl((this.isClient) ? (this.profile.clientProfile.OOPCosts) ? this.profile.clientProfile.OOPCosts.HospitalAndTest : '' : (this.profile.clientProfile.SpouseOOPCosts) ? this.profile.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest : ''),
      oopRXDrugs: new FormControl((this.isClient) ? (this.profile.clientProfile.OOPCosts) ? this.profile.clientProfile.OOPCosts.PrescriptionDrugs : '' : (this.profile.clientProfile.SpouseOOPCosts) ? this.profile.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs : ''),
      oopHearingVision: new FormControl((this.isClient) ? (this.profile.clientProfile.OOPCosts) ? this.profile.clientProfile.OOPCosts.HearingAndVisionCosts : '' : (this.profile.clientProfile.SpouseOOPCosts) ? this.profile.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts : ''),
      oopDental: new FormControl((this.isClient) ? (this.profile.clientProfile.OOPCosts) ? this.profile.clientProfile.OOPCosts.DentalCosts : '' : (this.profile.clientProfile.SpouseOOPCosts) ? this.profile.clientProfile.SpouseOOPCosts.SpouseDentalCosts : ''),

      applyToSpouse: new FormControl(this.profile.clientProfile.IsHSApplySpouse)
    });

    if(this.retirementHealthcare.value.medAdvantageHMO){
      this.retirementHealthcare.controls['medAdvantageHMO'].disable();
      if(this.retirementHealthcare.value.premDental){
        this.isSelectAllPremiums = true;
      }
    } else if(this.retirementHealthcare.value.medAdvantagePPO){
      this.retirementHealthcare.controls['medAdvantagePPO'].disable();
      if(this.retirementHealthcare.value.premDental){
        this.isSelectAllPremiums = true;
      }
    } else { //Traditional selected
      if(this.retirementHealthcare.value.premMedPartB 
        && this.retirementHealthcare.value.premMedPartD 
        && this.retirementHealthcare.value.premSupplemental
        && this.retirementHealthcare.value.premDental){
          this.isSelectAllPremiums = true;
        }
    }

    if(this.retirementHealthcare.value.oopHospDocsTests
      && this.retirementHealthcare.value.oopRXDrugs
      && this.retirementHealthcare.value.oopHearingVision
      && this.retirementHealthcare.value.oopDental
    ){
      this.isSelectAllOOP = true;
    }

    console.log('this.retirementHealthcare', this.retirementHealthcare);
    this.selectedRetirementAge = Number(this.retireInfo.value.retirementAge);
    console.log('this.selectedRetirementAge', this.selectedRetirementAge)

    //this.privateInsuranceChange(this.profile.clientProfile.IsPrivHealthIns);
    //this.displayInsurance = this.profile.clientProfile.IsPrivHealthIns;


    // this.isPre65 = (Number(this.profile.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profile.client.DOB)) >= 65) ? false: true;
    this.calculateLifeExp(true);
    /* if (this.isClient) {
      this.isPre65 = (Number(this.selectedRetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profile.client.DOB)) >= 65) ? false: true;
    }

    else {
      this.isPre65 = (Number(this.selectedRetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profile.clientProfile.Spouses[0].dob)) >= 65) ? false: true;

    } */
    
    this.isPre65 = (Number(this.selectedRetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profileInfo.value.dob) >= 65)) ? false : true;
    if (!this.isSelectAllPremiums && !this.isSelectAllOOP) {
      this.selectPremiumOrOOP(null);
    }

  }

  formatToString(section){  
    if(section == 'firstName'){
      this.profileInfo.controls['firstName'].patchValue(Utils.formatToString(this.profileInfo.value.firstName));
    } else if(section == 'lastName'){
      this.profileInfo.controls['lastName'].patchValue(Utils.formatToString(this.profileInfo.value.lastName));
    }
  }

  isSelectAllOOP = false;
  selectAllOOP(){
    if(!this.isSelectAllOOP){
      this.retirementHealthcare.controls['oopHospDocsTests'].setValue(true);
      this.retirementHealthcare.controls['oopRXDrugs'].setValue(true);
      this.retirementHealthcare.controls['oopHearingVision'].setValue(true);
      this.retirementHealthcare.controls['oopDental'].setValue(true);

      this.isSelectAllOOP = true;
    } else {
      this.retirementHealthcare.controls['oopHospDocsTests'].setValue(false);
      this.retirementHealthcare.controls['oopRXDrugs'].setValue(false);
      this.retirementHealthcare.controls['oopHearingVision'].setValue(false);
      this.retirementHealthcare.controls['oopDental'].setValue(false);
      
      this.isSelectAllOOP = false;
    }

    if(!this.retirementHealthcare.value.premMedPartB 
      && !this.retirementHealthcare.value.premMedPartD
      && !this.retirementHealthcare.value.premSupplemental
      && !this.retirementHealthcare.value.premDental
      && !this.retirementHealthcare.value.oopHospDocsTests
      && !this.retirementHealthcare.value.oopRXDrugs
      && !this.retirementHealthcare.value.oopHearingVision
      && !this.retirementHealthcare.value.oopDental){
        this.retirementHealthcare.controls['premMedPartB'].setValue(true);
        this.retirementHealthcare.controls['premMedPartD'].setValue(true);
    }

    this.selectPremiumOrOOP(true);
  }

  isSelectAllPremiums = false;
  selectAllPremiums(){
    if(this.retirementHealthcare.value.premiumType == 'HMO'){
      if(!this.isSelectAllPremiums){
        this.retirementHealthcare.controls['premDental'].setValue(true);
        this.isSelectAllPremiums = true;
      } else {
        this.retirementHealthcare.controls['premDental'].setValue(false);
        this.isSelectAllPremiums = false;      
      }
    } else {
      if(!this.isSelectAllPremiums){
        this.retirementHealthcare.controls['premMedPartB'].setValue(true);
        this.retirementHealthcare.controls['premMedPartD'].setValue(true);
        this.retirementHealthcare.controls['premSupplemental'].setValue(true);
        this.retirementHealthcare.controls['premDental'].setValue(true);

        this.isSelectAllPremiums = true;
      } else {
        //this.retirementHealthcare.controls['premMedPartB'].setValue(false);
        //this.retirementHealthcare.controls['premMedPartD'].setValue(false);
        this.retirementHealthcare.controls['premSupplemental'].setValue(false);
        this.retirementHealthcare.controls['premDental'].setValue(false);
        
        this.isSelectAllPremiums = false;
      }

      if(!this.retirementHealthcare.value.premMedPartB 
        && !this.retirementHealthcare.value.premMedPartD
        && !this.retirementHealthcare.value.premSupplemental
        && !this.retirementHealthcare.value.premDental
        && !this.retirementHealthcare.value.oopHospDocsTests
        && !this.retirementHealthcare.value.oopRXDrugs
        && !this.retirementHealthcare.value.oopHearingVision
        && !this.retirementHealthcare.value.oopDental){
          this.retirementHealthcare.controls['premMedPartB'].setValue(true);
          this.retirementHealthcare.controls['premMedPartD'].setValue(true);
      }

      this.selectPremiumOrOOP(false);
    }
  }

  
  selectPremiumOrOOP(premiums){

    //if(premiums){
      if(premiums && ((this.retirementHealthcare.value.medAdvantageHMO || this.retirementHealthcare.value.premiumType == 'HMO')
        || (this.retirementHealthcare.value.medAdvantagePPO || this.retirementHealthcare.value.premiumType == 'PPO')
        || (this.retirementHealthcare.value.premMedPartB 
          && this.retirementHealthcare.value.premMedPartD 
          && this.retirementHealthcare.value.premSupplemental))
          && this.retirementHealthcare.value.premDental){
            this.isSelectAllPremiums = true; 
        } else if (!premiums && this.retirementHealthcare.value.oopHospDocsTests
          && this.retirementHealthcare.value.oopRXDrugs
          && this.retirementHealthcare.value.oopHearingVision
          && this.retirementHealthcare.value.oopDental){
            this.isSelectAllOOP = true; 
          } else if (this.retirementHealthcare.value.premiumType == 'TM'){
          // at least one need to be selected
          console.log('this.retirementHealthcare.value', this.retirementHealthcare.value);
          this.isSelectAllPremiums = false; 
		  this.isSelectAllOOP = false; 

          this.retirementHealthcare.controls['premMedPartB'].enable();
          this.retirementHealthcare.controls['premMedPartD'].enable();
          //this.retirementHealthcare.controls['premSupplemental'].enable();
          this.retirementHealthcare.controls['premDental'].enable();
          
          this.retirementHealthcare.controls['oopHospDocsTests'].enable();
          this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
          this.retirementHealthcare.controls['oopHearingVision'].enable(); 
          this.retirementHealthcare.controls['oopDental'].enable();  

          if(this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental
            
            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['premMedPartB'].disable();  
              
              this.retirementHealthcare.controls['premDental'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   

              this.retirementHealthcare.controls['oopHospDocsTests'].enable();
              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();  
          } else if(!this.retirementHealthcare.value.premMedPartB 
            && this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental
            
            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['premMedPartD'].disable();   

              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premDental'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   

              this.retirementHealthcare.controls['oopHospDocsTests'].enable();
              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();  
          /* } else if(!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            && this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental
            
            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['premSupplemental'].disable();  
              
              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premDental'].enable();  
              
              this.retirementHealthcare.controls['oopHospDocsTests'].enable();
              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();  */ 
          } else if(!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && this.retirementHealthcare.value.premDental
            
            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['premDental'].disable();

              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   

              this.retirementHealthcare.controls['oopHospDocsTests'].enable();
              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();  
          } else if (!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental

            && this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['oopHospDocsTests'].disable();

              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();   

              this.retirementHealthcare.controls['premDental'].enable();
              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   
          } else if (!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental

            && !this.retirementHealthcare.value.oopHospDocsTests
            && this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              console.log('prevent RX uncheck');
              this.retirementHealthcare.controls['oopHospDocsTests'].enable();

              this.retirementHealthcare.controls['oopRXDrugs'].disable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].enable();   

              this.retirementHealthcare.controls['premDental'].enable();
              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   
          } else if (!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental

            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && this.retirementHealthcare.value.oopHearingVision
            && !this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['oopHospDocsTests'].enable();

              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].disable(); 
              this.retirementHealthcare.controls['oopDental'].enable();   

              this.retirementHealthcare.controls['premDental'].enable();
              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   
          } else if (!this.retirementHealthcare.value.premMedPartB 
            && !this.retirementHealthcare.value.premMedPartD 
            //&& !this.retirementHealthcare.value.premSupplemental
            && !this.retirementHealthcare.value.premDental

            && !this.retirementHealthcare.value.oopHospDocsTests
            && !this.retirementHealthcare.value.oopRXDrugs
            && !this.retirementHealthcare.value.oopHearingVision
            && this.retirementHealthcare.value.oopDental){
              this.retirementHealthcare.controls['oopHospDocsTests'].enable();

              this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
              this.retirementHealthcare.controls['oopHearingVision'].enable(); 
              this.retirementHealthcare.controls['oopDental'].disable();   

              this.retirementHealthcare.controls['premDental'].enable();
              this.retirementHealthcare.controls['premMedPartB'].enable(); 
              this.retirementHealthcare.controls['premMedPartD'].enable(); 
              this.retirementHealthcare.controls['premSupplemental'].enable();   
          }             
          
          if(!this.retirementHealthcare.value.premMedPartB && !this.retirementHealthcare.controls['premMedPartB'].disabled){
            this.retirementHealthcare.controls['premSupplemental'].setValue(false); 
            this.retirementHealthcare.controls['premSupplemental'].disable(); 
          } else {
            this.retirementHealthcare.controls['premSupplemental'].enable(); 
            if (this.retirementHealthcare.value.premMedPartB 
              && !this.retirementHealthcare.value.premMedPartD 
              && this.retirementHealthcare.value.premSupplemental
              && !this.retirementHealthcare.value.premDental
  
              && !this.retirementHealthcare.value.oopHospDocsTests
              && !this.retirementHealthcare.value.oopRXDrugs
              && !this.retirementHealthcare.value.oopHearingVision
              && !this.retirementHealthcare.value.oopDental){
                this.retirementHealthcare.controls['premMedPartB'].disable(); 
              }
          }
        }    
  }

  /* selectPremiumOrOOP(premiums){
    if(premiums){
      if(this.isSelectAllPremiums){
        this.isSelectAllPremiums = false;//!this.isSelectAllPremiums;
      } else if(((this.retirementHealthcare.value.medAdvantageHMO || this.retirementHealthcare.value.premiumType == 'HMO')
        || (this.retirementHealthcare.value.medAdvantagePPO || this.retirementHealthcare.value.premiumType == 'PPO')
        || (this.retirementHealthcare.value.premMedPartB 
          && this.retirementHealthcare.value.premMedPartD 
          && this.retirementHealthcare.value.premSupplemental))
          && this.retirementHealthcare.value.premDental){
          this.isSelectAllPremiums = true; 
        } else if (this.retirementHealthcare.value.premiumType == 'TM'){
          // at least one need to be selected
          console.log('this.retirementHealthcare.value', this.retirementHealthcare.value);

          //check if at least one is selected
          if(this.retirementHealthcare.value.premMedPartB 
            || this.retirementHealthcare.value.premMedPartD 
            || this.retirementHealthcare.value.premSupplemental
            || this.retirementHealthcare.value.premDental){

              this.retirementHealthcare.controls['premMedPartB'].enable();
              this.retirementHealthcare.controls['premMedPartD'].enable();
              this.retirementHealthcare.controls['premSupplemental'].enable();
              this.retirementHealthcare.controls['premDental'].enable();

              if(this.retirementHealthcare.value.premMedPartB 
                && !this.retirementHealthcare.value.premMedPartD 
                && !this.retirementHealthcare.value.premSupplemental
                && !this.retirementHealthcare.value.premDental
                
                && !this.retirementHealthcare.value.oopHospDocsTests
                && !this.retirementHealthcare.value.oopRXDrugs
                && !this.retirementHealthcare.value.oopHearingVision
                && !this.retirementHealthcare.value.oopDental){
                  this.retirementHealthcare.controls['premMedPartB'].disable();  
                  
                  this.retirementHealthcare.controls['premDental'].enable(); 
                  this.retirementHealthcare.controls['premMedPartD'].enable(); 
                  this.retirementHealthcare.controls['premSupplemental'].enable();   

                  this.retirementHealthcare.controls['oopHospDocsTests'].enable();
                  this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
                  this.retirementHealthcare.controls['oopHearingVision'].enable(); 
                  this.retirementHealthcare.controls['oopDental'].enable();  
              } else if(!this.retirementHealthcare.value.premMedPartB 
                && this.retirementHealthcare.value.premMedPartD 
                && !this.retirementHealthcare.value.premSupplemental
                && !this.retirementHealthcare.value.premDental
                
                && !this.retirementHealthcare.value.oopHospDocsTests
                && !this.retirementHealthcare.value.oopRXDrugs
                && !this.retirementHealthcare.value.oopHearingVision
                && !this.retirementHealthcare.value.oopDental){
                  this.retirementHealthcare.controls['premMedPartD'].disable();   

                  this.retirementHealthcare.controls['premMedPartB'].enable(); 
                  this.retirementHealthcare.controls['premDental'].enable(); 
                  this.retirementHealthcare.controls['premSupplemental'].enable();   

                  this.retirementHealthcare.controls['oopHospDocsTests'].enable();
                  this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
                  this.retirementHealthcare.controls['oopHearingVision'].enable(); 
                  this.retirementHealthcare.controls['oopDental'].enable();  
              } else if(!this.retirementHealthcare.value.premMedPartB 
                && !this.retirementHealthcare.value.premMedPartD 
                && this.retirementHealthcare.value.premSupplemental
                && !this.retirementHealthcare.value.premDental
                
                && !this.retirementHealthcare.value.oopHospDocsTests
                && !this.retirementHealthcare.value.oopRXDrugs
                && !this.retirementHealthcare.value.oopHearingVision
                && !this.retirementHealthcare.value.oopDental){
                  this.retirementHealthcare.controls['premSupplemental'].disable();  
                  
                  this.retirementHealthcare.controls['premMedPartB'].enable(); 
                  this.retirementHealthcare.controls['premMedPartD'].enable(); 
                  this.retirementHealthcare.controls['premDental'].enable();  
                  
                  this.retirementHealthcare.controls['oopHospDocsTests'].enable();
                  this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
                  this.retirementHealthcare.controls['oopHearingVision'].enable(); 
                  this.retirementHealthcare.controls['oopDental'].enable();  
              } else if(!this.retirementHealthcare.value.premMedPartB 
                && !this.retirementHealthcare.value.premMedPartD 
                && !this.retirementHealthcare.value.premSupplemental
                && this.retirementHealthcare.value.premDental
                
                && !this.retirementHealthcare.value.oopHospDocsTests
                && !this.retirementHealthcare.value.oopRXDrugs
                && !this.retirementHealthcare.value.oopHearingVision
                && !this.retirementHealthcare.value.oopDental){
                  this.retirementHealthcare.controls['premDental'].disable();

                  this.retirementHealthcare.controls['premMedPartB'].enable(); 
                  this.retirementHealthcare.controls['premMedPartD'].enable(); 
                  this.retirementHealthcare.controls['premSupplemental'].enable();   

                  this.retirementHealthcare.controls['oopHospDocsTests'].enable();
                  this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
                  this.retirementHealthcare.controls['oopHearingVision'].enable(); 
                  this.retirementHealthcare.controls['oopDental'].enable();  
              }              
              
              if(!this.retirementHealthcare.value.premMedPartB && !this.retirementHealthcare.controls['premMedPartB'].disabled){
                this.retirementHealthcare.controls['premSupplemental'].setValue(false); 
                this.retirementHealthcare.controls['premSupplemental'].disable(); 
              } else {
                this.retirementHealthcare.controls['premSupplemental'].enable(); 
              }
          } else {
            //this.retirementHealthcare.controls['premMedPartB'].setValue(true);
            //this.retirementHealthcare.controls['premMedPartD'].setValue(true);
          }
        }
    } else {
      if(this.isSelectAllOOP){
        this.isSelectAllOOP = false;//!this.isSelectAllOOP;
      } else if (this.retirementHealthcare.value.oopHospDocsTests
        && this.retirementHealthcare.value.oopRXDrugs
        && this.retirementHealthcare.value.oopHearingVision
        && this.retirementHealthcare.value.oopDental){
          this.isSelectAllOOP = true;
        }
        //if no Premium is selected, at least one OOP needs to be checked
        else if (!this.retirementHealthcare.value.premMedPartB 
          && !this.retirementHealthcare.value.premMedPartD 
          && !this.retirementHealthcare.value.premSupplemental
          && !this.retirementHealthcare.value.premDental

          && this.retirementHealthcare.value.oopHospDocsTests
          && !this.retirementHealthcare.value.oopRXDrugs
          && !this.retirementHealthcare.value.oopHearingVision
          && !this.retirementHealthcare.value.oopDental){
            this.retirementHealthcare.controls['oopHospDocsTests'].disable();

            this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
            this.retirementHealthcare.controls['oopHearingVision'].enable(); 
            this.retirementHealthcare.controls['oopDental'].enable();   

            this.retirementHealthcare.controls['premDental'].enable();
            this.retirementHealthcare.controls['premMedPartB'].enable(); 
            this.retirementHealthcare.controls['premMedPartD'].enable(); 
            this.retirementHealthcare.controls['premSupplemental'].enable();   
        } else if (!this.retirementHealthcare.value.premMedPartB 
          && !this.retirementHealthcare.value.premMedPartD 
          && !this.retirementHealthcare.value.premSupplemental
          && !this.retirementHealthcare.value.premDental

          && !this.retirementHealthcare.value.oopHospDocsTests
          && this.retirementHealthcare.value.oopRXDrugs
          && !this.retirementHealthcare.value.oopHearingVision
          && !this.retirementHealthcare.value.oopDental){
            this.retirementHealthcare.controls['oopHospDocsTests'].enable();

            this.retirementHealthcare.controls['oopRXDrugs'].disable(); 
            this.retirementHealthcare.controls['oopHearingVision'].enable(); 
            this.retirementHealthcare.controls['oopDental'].enable();   

            this.retirementHealthcare.controls['premDental'].enable();
            this.retirementHealthcare.controls['premMedPartB'].enable(); 
            this.retirementHealthcare.controls['premMedPartD'].enable(); 
            this.retirementHealthcare.controls['premSupplemental'].enable();   
        } else if (!this.retirementHealthcare.value.premMedPartB 
          && !this.retirementHealthcare.value.premMedPartD 
          && !this.retirementHealthcare.value.premSupplemental
          && !this.retirementHealthcare.value.premDental

          && !this.retirementHealthcare.value.oopHospDocsTests
          && !this.retirementHealthcare.value.oopRXDrugs
          && this.retirementHealthcare.value.oopHearingVision
          && !this.retirementHealthcare.value.oopDental){
            this.retirementHealthcare.controls['oopHospDocsTests'].enable();

            this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
            this.retirementHealthcare.controls['oopHearingVision'].disable(); 
            this.retirementHealthcare.controls['oopDental'].enable();   

            this.retirementHealthcare.controls['premDental'].enable();
            this.retirementHealthcare.controls['premMedPartB'].enable(); 
            this.retirementHealthcare.controls['premMedPartD'].enable(); 
            this.retirementHealthcare.controls['premSupplemental'].enable();   
        } else if (!this.retirementHealthcare.value.premMedPartB 
          && !this.retirementHealthcare.value.premMedPartD 
          && !this.retirementHealthcare.value.premSupplemental
          && !this.retirementHealthcare.value.premDental

          && !this.retirementHealthcare.value.oopHospDocsTests
          && !this.retirementHealthcare.value.oopRXDrugs
          && !this.retirementHealthcare.value.oopHearingVision
          && this.retirementHealthcare.value.oopDental){
            this.retirementHealthcare.controls['oopHospDocsTests'].enable();

            this.retirementHealthcare.controls['oopRXDrugs'].enable(); 
            this.retirementHealthcare.controls['oopHearingVision'].enable(); 
            this.retirementHealthcare.controls['oopDental'].disable();   

            this.retirementHealthcare.controls['premDental'].enable();
            this.retirementHealthcare.controls['premMedPartB'].enable(); 
            this.retirementHealthcare.controls['premMedPartD'].enable(); 
            this.retirementHealthcare.controls['premSupplemental'].enable();   
        }
    }
  } */

  selectPremiumType(){
    /* if(this.retirementHealthcare.value.medAdvantageHMO || this.retirementHealthcare.value.medAdvantagePPO){
      this.retirementHealthcare.controls['premMedPartB'].setValue(true);
      this.retirementHealthcare.controls['premMedPartD'].setValue(true);
    } */

    if(this.retirementHealthcare.value.premiumType == 'HMO'){
      this.retirementHealthcare.controls['medAdvantageHMO'].setValue(true);
      this.retirementHealthcare.controls['medAdvantageHMO'].disable();      
    } else {
      this.retirementHealthcare.controls['medAdvantageHMO'].setValue(false);
    }

    if(this.retirementHealthcare.value.premiumType == 'PPO'){
      this.retirementHealthcare.controls['medAdvantagePPO'].setValue(true);
      this.retirementHealthcare.controls['medAdvantagePPO'].disable();
    } else {
      this.retirementHealthcare.controls['medAdvantagePPO'].setValue(false);
    }

    if(this.retirementHealthcare.value.premiumType == 'HMO' || this.retirementHealthcare.value.premiumType == 'PPO'){
      if(this.retirementHealthcare.value.premDental){
        this.isSelectAllPremiums = true;
      } else {
        this.isSelectAllPremiums = false;
      }
    } else {
      if(!this.retirementHealthcare.value.premMedPartB){
        //this.retirementHealthcare.controls['premSupplemental'].setValue(false); 
        //this.retirementHealthcare.controls['premSupplemental'].disable(); 
        //this.retirementHealthcare.controls['premMedPartB'].setValue(true);
        //this.retirementHealthcare.controls['premMedPartB'].enable(); 
        this.retirementHealthcare.controls['premSupplemental'].enable(); 
        if(!this.retirementHealthcare.value.premMedPartD && !this.retirementHealthcare.value.premDental){          
          //this.retirementHealthcare.controls['premMedPartD'].setValue(true); 
          //this.retirementHealthcare.controls['premMedPartD'].enable(); 
        }
      } else {
        this.retirementHealthcare.controls['premSupplemental'].enable(); 
      }

      if(this.retirementHealthcare.value.premMedPartB 
        && this.retirementHealthcare.value.premMedPartD 
        && this.retirementHealthcare.value.premSupplemental
        && this.retirementHealthcare.value.premDental){
          this.isSelectAllPremiums = true;
      } else {
        this.isSelectAllPremiums = false;
      }
        
      if(!this.isSelectAllPremiums 
        && !this.retirementHealthcare.value.premMedPartB 
        && !this.retirementHealthcare.value.premMedPartD
        && !this.retirementHealthcare.value.premSupplemental
        && !this.retirementHealthcare.value.premDental){
          //this.retirementHealthcare.controls['premMedPartB'].setValue(true);
          //this.retirementHealthcare.controls['premMedPartD'].setValue(true);
      }

      if(!this.retirementHealthcare.value.premMedPartB 
        && !this.retirementHealthcare.value.premMedPartD
        && !this.retirementHealthcare.value.premSupplemental
        && !this.retirementHealthcare.value.premDental
        && !this.retirementHealthcare.value.oopHospDocsTests
        && !this.retirementHealthcare.value.oopRXDrugs
        && !this.retirementHealthcare.value.oopHearingVision
        && !this.retirementHealthcare.value.oopDental){
          this.retirementHealthcare.controls['premMedPartB'].setValue(true);
          this.retirementHealthcare.controls['premMedPartD'].setValue(true);

          this.selectPremiumOrOOP(true);
      }
    }
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  genderConvert(genderID){
    return (genderID == 1) ? 'Female' : 'Male';
  }

  maritalStatusConvert(maritalStatus){
    //return (maritalStatus == 1) ? 'Single' : 'Married'; //Divorced | Widowed
    var spouse = JSON.parse(this.profile.clientProfile.Spouses);
    return (spouse[0] && spouse[0].maritalStatus == 'Married') ? 'Married' : 'Single';
  }

  healthConditionConvert(clientProfile){
    var result = "";
    if(clientProfile.HCHBP > 0){
      result += "High Blood Pressure"
    }

    if(clientProfile.HCHC > 0){
      result += ((result == "") ? "" : ", ") + "High Cholesterol"
    }

    if(clientProfile.HCT2D > 0){
      result += ((result == "") ? "" : ", ") + "Type 2 Diabetes"
    }

    if(clientProfile.HCCD > 0){
      result += ((result == "") ? "" : ", ") + "Cardiovascular Disease"
    }

    if(clientProfile.HCC > 0){
      result += ((result == "") ? "" : ", ") + "Cancer"
    }

    if(clientProfile.HCT > 0){
      result += ((result == "") ? "" : ", ") + "Tobacco"
    }
    
    return ((result == "") ? "No Conditions" : result);
  }

  bracketCalculationRedirect(){
    //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'income' } });
    var editRouteVariable = 'healthcare';
    if(this.router.url.includes('/clients/edit')){
      //if on client hub, use whatever you can is set for features to figure out the questionnaire
      // let isHCFilledBefore = this.selectedClient.clientProfile.PremiumType ? true: false;
      // let isSSFilled = this.profile.clientProfile.MonthlyBenefitAmount || this.profile.clientProfile.PIA || this.profile.clientProfile.SelfKnownBenefitClaiming ? true : false;
      // console.log('isSSFilled', isSSFilled)
      //if on illustration, use that illustration questionnaire for income
      if(this.router.url.includes('/social-security')){
        console.log('here 01');
        editRouteVariable = 'social-security';
      } else {
        //editRouteVariable = 'healthcare';
        if(this.globalService.featHealthCare || this.globalService.featCombinedHealthcareLTC || this.globalService.featLongTermCare){
          console.log('here 02');
          editRouteVariable = 'healthcare';
        } else {
          console.log('here 03');
          //Social Security
          editRouteVariable = 'social-security';
        }
      }
    }
    
    //this.router.navigate([this.router.url]);
    
    //
    //this.directBackToTabView();
    // this.router.navigate(['/clients/edit/social-security'], { state: { params: 'income' } });
    this.router.navigate(['/clients/edit/' + editRouteVariable], { state: { params: 'income' } });
  }

  //editRouteVariable;
  handleSidebarStatus(url) {
    /* console.log('url from side', url);
    if(url.includes('/clients/edit')){
      //if on client hub, use whatever you can is set for features to figure out the questionnaire
      if(this.globalService.featHealthCare || this.globalService.featCombinedHealthcareLTC || this.globalService.featLongTermCare){
        this.editRouteVariable = 'healthcare';
      } else {
        //Social Security
        this.editRouteVariable = 'social-security';
      }
    } else {
      //if on illustration, use that illustration questionnaire for income
      if(url.includes('/social-security')){
        this.editRouteVariable = 'social-security';
      } else {
        this.editRouteVariable = 'healthcare';
      }
    } */
  }

  setClientBracket(income){
    if(income >= this.responseMMTBracket.Bracket1 && income <= this.responseMMTBracket.Bracket2 - 1){
      return 1;
    } else if(income >= this.responseMMTBracket.Bracket2 && income <= this.responseMMTBracket.Bracket3 - 1){
      return 2;
    } else if(income >= this.responseMMTBracket.Bracket3 && income <= this.responseMMTBracket.Bracket4 - 1){
      return 3;
    } else if(income >= this.responseMMTBracket.Bracket4 && income <= this.responseMMTBracket.Bracket5 - 1){
      return 4;
    } else if(income >= this.responseMMTBracket.Bracket5 && income <= this.responseMMTBracket.Bracket6 - 1){
      return 5;
    } else {
      return 6;
    }
  }

  stateChange(value){
    //console.log('state selected', value);
    this.retireInfo.controls['retirementState'].setValue(value);
    //by default, once the state is changed, swap metro region to state average
    this.retireInfo.controls['retirementStateMetroArea'].setValue('0');
    this.getLTCStateRegions(value);
  }


  //displayInsurance;// = true;
  privateInsuranceChange(value){
    //this.displayInsurance = value;
    this.retirementHealthcare.controls['needPrivateInsurance'].setValue(value);
  }

  lifeExpLessThanRetirementAge: boolean = false;
  lifeExpLessThanCurrentAge: boolean = false;
  calculateLifeExp(isOnPageLoad = false, isClose = false, isSaveClient = false){

    let gender = isClose ? (this.isClient) ? this.profile.client.GenderID : this.selectedClientSpouse[0].gender : Number(this.profileInfo.value.gender);
    let dob = isClose ? new Date((this.isClient) ? this.profile.client.DOB : this.selectedClientSpouse[0].maritalStatus == "Married"? this.selectedClientSpouse[0].dob: this.selectedClientSpouse[0].dobStr) : this.profileInfo.value.dob;
    let HCC = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCC : this.selectedClientSpouse[0].HCC) > 0) ? true : false) : this.healthInfo.value.cancer;
    let HCCD = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCCD : this.selectedClientSpouse[0].HCCD) > 0) ? true : false) : this.healthInfo.value.cardioDisease;
    let HCHBP = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCHBP : this.selectedClientSpouse[0].HCHBP) > 0) ? true : false) : this.healthInfo.value.highBP;
    let HCHC = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCHC : this.selectedClientSpouse[0].HCHC) > 0) ? true : false): this.healthInfo.value.highChol;
    let HCT = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCT : this.selectedClientSpouse[0].HCT) > 0) ? true : false): this.healthInfo.value.tobacco;
    let HCT2D = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCT2D : this.selectedClientSpouse[0].HCT2D) > 0) ? true : false):this.healthInfo.value.type2Diab;
    let HCT1D = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCT1D : this.selectedClientSpouse[0].HCT1D) > 0) ? true : false):(this.healthInfo.value.type1Diab);
    let HCMS = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCMS : this.selectedClientSpouse[0].HCMS) > 0) ? true : false): (this.healthInfo.value.multSclerosis);
    let HCDCW = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCDCW : this.selectedClientSpouse[0].HCDCW) > 0) ? true : false):(this.healthInfo.value.depCaneWalker);
    let HCFHDC = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCFHDC : this.selectedClientSpouse[0].HCFHDC) > 0) ? true : false): (this.healthInfo.value.famHistory);

    let HCALZ = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCALZ : this.selectedClientSpouse[0].HCALZ) > 0) ? true : false): (this.healthInfo.value.alzheimers);
    let HCPARK = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCPARK : this.selectedClientSpouse[0].HCPARK) > 0) ? true : false): (this.healthInfo.value.parkinsons);
    let HCAMP = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCAMP : this.selectedClientSpouse[0].HCAMP) > 0) ? true : false): (this.healthInfo.value.amputation);
    let HCPTSD = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCPTSD : this.selectedClientSpouse[0].HCPTSD) > 0) ? true : false): (this.healthInfo.value.ptsd);
    let HCOBS = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCOBS : this.selectedClientSpouse[0].HCOBS) > 0) ? true : false): (this.healthInfo.value.obesity);

    let HCCYrsDiag = isClose ?((((this.isClient) ? this.profile.clientProfile.HCCYrsDiag : this.selectedClientSpouse[0].HCCYrsDiag) > 0) ? true : false) :this.healthInfo.value.cancerYearsDiagnosed;
    let HCCDYrsDiag = isClose ? ((((this.isClient) ? this.profile.clientProfile.HCCDYrsDiag : this.selectedClientSpouse[0].HCCDYrsDiag) > 0) ? true : false):this.healthInfo.value.cardioDiseaseYearsDiagnosed;
    
    var LEObject = {
      gender: Number(gender),
      age: this.calculateAge(dob),
      healthConditions: {
        HCC: HCC ? 1 : 0, //HCC
        HCCD: HCCD ? 1 : 0, //HCCD
        HCHBP: HCHBP ? 1 : 0, //HCHBP
        HCHC: HCHC ? 1 : 0, //HCHC
        HCT: HCT ? 1 : 0, //HCT
        HCT2D: HCT2D ? 1 : 0, //HCT2D
        HCT1D: HCT1D? 1 : 0,
        HCMS: HCMS ? 1 : 0,
        HCDCW: HCDCW? 1 : 0,
        HCFHDC: HCFHDC ? 1 : 0,
        HCCYrsDiag: HCCYrsDiag ? 1 : 0,
        HCCDYrsDiag: HCCDYrsDiag ? 1 : 0,
        
        HCALZ: HCALZ ? 1 : 0,
        HCPARK: HCPARK ? 1 : 0,
        HCAMP: HCAMP ? 1 : 0,
        HCPTSD: HCPTSD ? 1 : 0,
        HCOBS: HCOBS ? 1 : 0
      }
    }
    this.globalService.getLE(LEObject)
      .subscribe(
        le => {
          if (this.isClient) {
            // this.profile.clientProfile.CalculatedLifeExpectancy = parseInt(le);
            this.calculateLifeExpectancy = parseInt(le);
          } else {
            // var spouseOne = this.selectedClientSpouse[0];
            // spouseOne.CalculatedLifeExpectancy =  parseInt(le);
            // this.profile.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
            this.spouseCalculateLifeExpectancy = parseInt(le);
          }
          if (isSaveClient) {
            if (this.isClient) {
              this.editedClient.clientProfile.LifeExpectancy = parseInt(le);
              this.profile.clientProfile.LifeExpectancy = parseInt(le);
            } else {
              console.log('this.editedClient 00', this.editedClient);
              console.log('this.editedClient 00',this.editedClient.clientProfile.Spouses[0].maritalStatus);
              let spouses = JSON.parse(this.editedClient.clientProfile.Spouses);
              if (spouses[0].maritalStatus == 'Married') {
                spouses[0].LifeExpectancy = parseInt(le);
                this.editedClient.clientProfile.Spouses = JSON.stringify(spouses);
                // this.editedClient.clientProfile.Spouses[0].LifeExpectancy = parseInt(le);
                this.profile.clientProfile.Spouses = JSON.stringify(spouses);
              }
            }
            this.saveClientV2(this.editedClient);
          } else {
            if(!isOnPageLoad){
              //check if less than LE first
              if(parseInt(le) < this.profile.clientProfile.RetirementAge){
                this.lifeExpLessThanRetirementAge = true;
                this.lifeExpLessThanCurrentAge = false;
              } else if(parseInt(le) < this.profile.clientProfile.CurrentAge){
                this.lifeExpLessThanRetirementAge = false;
                this.lifeExpLessThanCurrentAge = true;
              } else {
                this.lifeExpLessThanRetirementAge = false;
                this.lifeExpLessThanCurrentAge = false;
              }

              //TODO: check if LE is less than Retire Age due to condition adjustments
              if(parseInt(this.retireInfo.value.retirementAge) >= parseInt(le)){
                //TODO: display modal explaining in here
                const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
                  data: { title: 'Notification!', 
                  question: "Retirement Age and/or Life Expectancy may be automatically updated in the Client Profile to ensure that<br/>retirement begins before end-of-life, for the purposes of this illustration.", 
                  btnYesTitle: 'I Understand' }
                });
          
                dialogRef.afterClosed().subscribe(result => {
                  if(result){
                    //then allow the LE to be updated
                    dialogRef.close();
          
                  } else {
                    dialogRef.close();
                  }
                });

                this.healthInfo.patchValue({ lifeExp: parseInt(le) + 1 });
              } else {
                this.healthInfo.patchValue({ lifeExp: parseInt(le) });
              }
            }
          }

        },
        error => { this.error = <any>error; });
  }

  // checkLifeExpValidation(value){
  //   console.log('here i am');
  //   //check if the validation on LE is on and should be corrected
  //   if(this.lifeExpLessThanRetirementAge){
  //     //is reset LE greater than or equal too now?
  //     if(value >= this.profile.clientProfile.CalculatedLifeExpectancy){
  //       this.lifeExpLessThanRetirementAge = false;
  //     }
  //   } else {
  //     if(value < this.calculateAge(this.profile.client.DOB)) {
  //       this.lifeExpLessThanCurrentAge = true;
  //     } else {
  //     //if not Retre age, check the current age 
  //       if(this.lifeExpLessThanCurrentAge){
  //         //reset if needed
  //         if(value >= this.profile.clientProfile.CalculatedLifeExpectancy){
  //           this.lifeExpLessThanCurrentAge = false;
  //         }
  //       }
  //     }
  //   }
  // }

  checkLifeExpValidation(value) {

    this.lifeExpLessThanRetirementAge = this.isClient ? (value < this.profile.clientProfile.RetirementAge ? true : false) : (value < this.selectedClientSpouse[0].retirementAge ? true : false);
    if (!this.lifeExpLessThanRetirementAge) {
      this.lifeExpLessThanCurrentAge = this.isClient ? (value < this.calculateAge(this.profile.client.DOB) ? true : false) : (value < this.calculateAge(this.selectedClientSpouse[0].dob) ? true : false);
    }
  }
  

  responseMMTBracket;
  getMMTBracket() {
    this.profile.clientProfile.Spouses = JSON.parse(this.profile.clientProfile.Spouses);
    let includePartner = this.profile.clientProfile.Spouses[0] && this.profile.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.profile.clientProfile.RetirementAge, this.profile.client.DOB));
    let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.profile.clientProfile.Spouses[0].retirementAge, this.profile.clientProfile.Spouses[0].dob)): null;
    let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
    console.log('bracketYear', bracketYear);
    this.profile.clientProfile.Spouses = JSON.stringify(this.profile.clientProfile.Spouses);
    this.globalService.getMMTBracket(includePartner, currentYear)
      .subscribe(
          data => {
            this.responseMMTBracket = data;
            console.log('MMT Brackets for Client', data);                  
            //If no bracket is set to the client profile, lets find the bracket for them
            /* if(this.incomeRangeSelectionForm.value.BracketValue == ''){
              
            } */
          },
          error => console.log(error));
  }

  responseLTCMetroRegions;
  getLTCStateRegions(state){
    this.globalService.getLTCStateRegions(state)
      .subscribe(
          data => {
            //console.log('metro regions', data);
            this.responseLTCMetroRegions = data;  
            
            if(this.isClient){
              //we need to do a check to make this backwards compatible for already existing clients
              if(this.profile.clientProfile.ClientMetroArea == ''){
                if(this.responseLTCMetroRegions.Rows.some(item => item.MetroRegionCode != this.profile.clientProfile.ClientMetroArea)){
                  //if in here, we need to set metro region to 'State Average'
                  this.retireInfo.controls['retirementStateMetroArea'].setValue('0');
                }
              }
            } else {
              if(this.profile.clientProfile.SpouseMetroArea == ''){
                if(this.responseLTCMetroRegions.Rows.some(item => item.MetroRegionCode != this.profile.clientProfile.SpouseMetroArea)){
                  //if in here, we need to set metro region to 'State Average'
                  this.retireInfo.controls['retirementStateMetroArea'].setValue('0');
                }
              }
            }
          },
          error => console.log(error));
  }

  save(){
    console.log('this.selectedClientSpouse[0]',this.selectedClientSpouse[0]);
    var updatedClient = this.profile;
    this.isSavedBtnClicked = true;
    //this.profile = updatedClient;
    updatedClient.clientProfile.Premiums = JSON.stringify(updatedClient.clientProfile.Premiums);
    updatedClient.clientProfile.OOPCosts = JSON.stringify(updatedClient.clientProfile.OOPCosts);

    if(this.maritalStatusConvert(updatedClient.clientProfile.MaritalStatus) == 'Married'){
      updatedClient.clientProfile.SpousePremiums = JSON.stringify(updatedClient.clientProfile.SpousePremiums);
      updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);
    }

    let needsRecalculatedLE = new Date(this.profileInfo.value.dob).toLocaleDateString() != new Date(updatedClient.client.DOB).toLocaleDateString();

    //TODO: check for which section are we updated
    if(this.section == 'my-information'){
      //validate that sections form; make sure valid
      if(this.profileInfo.valid){
        //TODO: update updatedClient to pass to the save function 'saveClientV2'
        if(this.isClient){
          //update client profile
          console.log('this.profileInfo.value.dob', this.profileInfo.value.dob);
          let clientDOB = ((new Date(this.profileInfo.value.dob).getMonth()) + 1) + '/' + new Date(this.profileInfo.value.dob).getDate() + '/' + new Date(this.profileInfo.value.dob).getFullYear() + ' 00:00:00';
          updatedClient.client.FirstName = this.profileInfo.value.firstName;
          updatedClient.client.LastName = this.profileInfo.value.lastName;
          updatedClient.client.GenderID = this.profileInfo.value.gender;
          updatedClient.client.DOB = clientDOB;
          updatedClient.clientProfile.IsLegalSpouse = this.profileInfo.value.isLegalSpouse == '1' ? 1: 0;
          updatedClient.clientProfile.runReportWithSpouse = this.profileInfo.value.runReportWithSpouse;
          updatedClient.clientProfile.LifeExpectancy = this.healthInfo.value.lifeExp;

          // TODO: do we need to remove other married information if client select from married to single.
          // Also what info to pass if the LegalSpouse is false
          if (this.selectedClientSpouse[0].maritalStatus == "Married") {
            if (!this.profileInfo.value.runReportWithSpouse) {
              this.selectedClientSpouse[0].maritalStatus = "Single";
            } else if (this.profileInfo.value.runReportWithSpouse) {
              this.selectedClientSpouse[0].isLegalSpouse = this.profileInfo.value.isLegalSpouse == '1' ? 1: 0;
              // updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
            }
          }
          //updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);

          //TODO: need to check if we need to adjust Already Claming after DOB adjusts
          var currentYear = new Date().getFullYear();
          if(currentYear - new Date(this.profileInfo.value.dob).getFullYear() < 62){
            if(this.isClient && updatedClient.clientProfile.SelfAlreadyCollecting == true){
              updatedClient.clientProfile.SelfAlreadyCollecting = false;
            } else if (!this.isClient && updatedClient.clientProfile.SpouseAlreadyCollecting == true){
              updatedClient.clientProfile.SpouseAlreadyCollecting = false;
            }
          }
          
        } else {
          //update the spouse proifle (leave client profile alone here)
          //convert to object
          //var selectedClientSpouse = JSON.parse(updatedClient.client.clientProfile.Spouses);
          var spouseOne = this.selectedClientSpouse[0];
          console.log(new Date(spouseOne.dob).toLocaleDateString())
          console.log(new Date(this.profileInfo.value.dob).toLocaleDateString())
          needsRecalculatedLE = new Date(this.profileInfo.value.dob).toLocaleDateString() != new Date(spouseOne.dob).toLocaleDateString();

          //TODO: set object for spouse
          spouseOne.dob = this.profileInfo.value.dob;
          spouseOne.gender = this.profileInfo.value.gender;
          spouseOne.firstName = this.profileInfo.value.firstName;
          spouseOne.lastName = this.profileInfo.value.lastName;
          spouseOne.LifeExpectancy = this.healthInfo.value.lifeExp;
          
          //convert back to json string
          //updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
          
        }

        //per Daley: if DOB is updated/changed, wipe DCA from both client and sposue
        if(!this.displayLifeExpPopup){
          console.log('in here cause LE is false');
          updatedClient.clientProfile.SSDesiredAgeYears = 0;
          updatedClient.clientProfile.SSDesiredAgeMonths = 0;

          if (this.selectedClientSpouse[0].maritalStatus == "Married" && this.profileInfo.value.runReportWithSpouse) {
            
            //convert back to json string
            //updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
            var spouseOne = this.selectedClientSpouse[0];
            spouseOne.sSDesiredAgeYears = 0;
            spouseOne.sSDesiredAgeMonths = 0;
          }          
        }

        localStorage.setItem('dateOfBirthModified', (!this.displayLifeExpPopup) ? 'true' : 'false');
        console.log('dateOfBirthModified check again', localStorage.getItem('dateOfBirthModified'));
        let spouseDOB = '';
        if (!this.isClient) {
          spouseDOB = ((new Date(this.profileInfo.value.dob).getMonth()) + 1) + '/' + new Date(this.profileInfo.value.dob).getDate() + '/' + new Date(this.profileInfo.value.dob).getFullYear() + ' 00:00:00';;
          this.selectedClientSpouse[0].dob = spouseDOB;
        }

        //convert back to json string
        updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
        console.log('this.selectedClientSpouse',JSON.stringify(this.selectedClientSpouse));        
        console.log('updatedClient.client.FirstName', updatedClient.client.FirstName);
        console.log('this.profile.client.FirstName',this.profile.client.FirstName);
        this.editedClient = updatedClient;
        console.log('this.editedClient', this.editedClient);

        if (needsRecalculatedLE) {
          var LEObject = {
            gender: Number(this.isClient ? updatedClient.client.GenderID : this.profileInfo.value.gender),
            age: this.calculateAge(this.isClient ? this.profileInfo.value.dob : this.profileInfo.value.dob),
            healthConditions: {
              HCC: this.healthInfo.value.cancer ? 1 : 0,
              HCCD: this.healthInfo.value.cardioDisease ? 1 : 0,
              HCHBP: this.healthInfo.value.highBP ? 1 : 0,
              HCHC: this.healthInfo.value.highChol ? 1 : 0,
              HCT: this.healthInfo.value.tobacco ? 1 : 0,
              HCT2D: this.healthInfo.value.type2Diab ? 1 : 0,
              HCT1D: this.healthInfo.value.type1Diab ? 1 : 0,
              HCMS: this.healthInfo.value.multSclerosis ? 1 : 0,
              HCDCW: this.healthInfo.value.depCaneWalker ? 1 : 0,
              HCFHDC: this.healthInfo.value.famHistory ? 1 : 0,

              HCALZ: this.healthInfo.value.alzheimers ? 1 : 0,
              HCPARK: this.healthInfo.value.parkinsons ? 1 : 0,
              HCAMP: this.healthInfo.value.amputation ? 1 : 0,
              HCPTSD: this.healthInfo.value.ptsd ? 1 : 0,
              HCOBS: this.healthInfo.value.obesity ? 1 : 0,

              HCCYrsDiag: this.healthInfo.value.cancerYearsDiagnosed ? 1 : 0,
              HCCDYrsDiag: this.healthInfo.value.cardioDiseaseYearsDiagnosed ? 1 : 0
            }
          }

          this.globalService.getLE(LEObject)
          .subscribe(
            le => {
              if (this.isClient) {
                updatedClient.clientProfile.LifeExpectancy = le;
                updatedClient.clientProfile.CalculatedLifeExpectancy = le;
              } else {
                spouseOne.LifeExpectancy = le;
                spouseOne.CalculatedLifeExpectancy = le;
                this.selectedClientSpouse[0] = spouseOne;
                this.selectedClientSpouse[0].dob = spouseDOB;
                console.log('this.selectedClientSpouse[0].dob', this.selectedClientSpouse[0].dob )
                updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
              }

              this.saveClientV2(updatedClient);
            },
            error => { this.error = <any>error; });
        } else {
          this.saveClientV2(updatedClient);
        }

        // if (((updatedClient.client.FirstName != this.profileOrg .client.FirstName) || ((updatedClient.client.LastName != this.profileOrg.client.LastName))) || (this.selectedClientSpouse[0].maritalStatus == "Married"? ((this.profileOrg.clientProfile.Spouses[0].firstName != updatedClient.clientProfile.Spouses[0].firstName) || (this.profileOrg.clientProfile.Spouses[0].lastName != updatedClient.clientProfile.Spouses[0].lastName)):false)) {
          
        // } else {
        //   this.calculateLifeExp(false, true, this.isSavedBtnClicked);
        // }
        // this.saveClientV2(updatedClient);
      }
    } else if(this.section == 'my-health-information'){
      //validate that sections form; make sure valid
      if(this.healthInfo.valid){

        console.log(this.healthInfo.value)

        if(this.isClient){
          //update client profile
          updatedClient.clientProfile.HCHBP = (this.healthInfo.value.highBP) ? 1 : 0;
          updatedClient.clientProfile.HCHC = (this.healthInfo.value.highChol) ? 1 : 0;
          updatedClient.clientProfile.HCCD = (this.healthInfo.value.cardioDisease) ? 1 : 0;
          updatedClient.clientProfile.HCT1D = (this.healthInfo.value.type1Diab) ? 1 : 0;
          updatedClient.clientProfile.HCT2D = (this.healthInfo.value.type2Diab) ? 1 : 0;
          updatedClient.clientProfile.HCC = (this.healthInfo.value.cancer) ? 1 : 0;
          updatedClient.clientProfile.HCT = (this.healthInfo.value.tobacco) ? 1 : 0;
          updatedClient.clientProfile.HCMS = (this.healthInfo.value.multSclerosis) ? 1 : 0;
          updatedClient.clientProfile.HCDCW = (this.healthInfo.value.depCaneWalker) ? 1 : 0;
          updatedClient.clientProfile.HCFHDC = (this.healthInfo.value.famHistory) ? 1 : 0;

          updatedClient.clientProfile.HCALZ = (this.healthInfo.value.alzheimers) ? 1 : 0;
          updatedClient.clientProfile.HCPARK = (this.healthInfo.value.parkinsons) ? 1 : 0;
          updatedClient.clientProfile.HCAMP = (this.healthInfo.value.amputation) ? 1 : 0;
          updatedClient.clientProfile.HCPTSD = (this.healthInfo.value.ptsd) ? 1 : 0;
          updatedClient.clientProfile.HCOBS = (this.healthInfo.value.obesity) ? 1 : 0;
          // updatedClient.clientProfile.LifeExpectancy = this.healthInfo.value.lifeExp;
          updatedClient.clientProfile.LifeExpectancy = this.healthInfo.value.lifeExp;
          updatedClient.clientProfile.CalculatedLifeExpectancy = this.calculateLifeExpectancy;
          localStorage.setItem('clientLifeExpectancy', updatedClient.clientProfile.LifeExpectancy);
        } else {
          //update the spouse proifle (leave client profile alone here)
          //convert to object
          //var selectedClientSpouse = JSON.parse(updatedClient.client.clientProfile.Spouses);
          var spouseOne = this.selectedClientSpouse[0];

          //TODO: set object for spouse
          spouseOne.HCHBP = (this.healthInfo.value.highBP) ? 1 : 0;
          spouseOne.HCHC = (this.healthInfo.value.highChol) ? 1 : 0;
          spouseOne.HCCD = (this.healthInfo.value.cardioDisease) ? 1 : 0;
          spouseOne.HCT1D = (this.healthInfo.value.type1Diab) ? 1 : 0; //not in API yet
          spouseOne.HCT2D = (this.healthInfo.value.type2Diab) ? 1 : 0;
          spouseOne.HCC = (this.healthInfo.value.cancer) ? 1 : 0;
          spouseOne.HCT = (this.healthInfo.value.tobacco) ? 1 : 0;
          spouseOne.HCMS = (this.healthInfo.value.multSclerosis) ? 1 : 0;
          spouseOne.HCDCW = (this.healthInfo.value.depCaneWalker) ? 1 : 0;
          spouseOne.HCFHDC = (this.healthInfo.value.famHistory) ? 1 : 0;

          spouseOne.HCALZ = (this.healthInfo.value.alzheimers) ? 1 : 0;
          spouseOne.HCPARK = (this.healthInfo.value.parkinsons) ? 1 : 0;
          spouseOne.HCAMP = (this.healthInfo.value.amputation) ? 1 : 0;
          spouseOne.HCPTSD = (this.healthInfo.value.ptsd) ? 1 : 0;
          spouseOne.HCOBS = (this.healthInfo.value.obesity) ? 1 : 0;
          //spouseOne.multSclerosis = this.healthInfo.value.multSclerosis;//not in API yet
          //spouseOne.depCaneWalker = this.healthInfo.value.depCaneWalker;//not in API yet
          //spouseOne.famHistory = this.healthInfo.value.famHistory;//not in API yet
          spouseOne.LifeExpectancy = this.healthInfo.value.lifeExp;
          spouseOne.CalculatedLifeExpectancy = this.spouseCalculateLifeExpectancy;
          localStorage.setItem('spouseLifeExpectancy', spouseOne.LifeExpectancy);

          //convert back to json string
          updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
        }

        console.log('updateClient', updatedClient);
        //move this into each if statement? leave it outside?
        //this.calculateLifeExp(false, false, true);
        this.editedClient = updatedClient;
        // this.calculateLifeExp(false, true, this.isSavedBtnClicked)
        if(this.healthInfo.value.lifeExp == this.calculateLifeExpectancy){
          this.calculateLifeExp(false, false, true);
        }
        //this.calculateLifeExp(false, false, true);
        this.saveClientV2(updatedClient);
      }
    
    } else if(this.section == 'my-income'){
      //validate that sections form; make sure valid
      if(this.incomeInfo.valid){
        //TODO: if incomeOption=1 and it was =2 then we need to make sure that this saves correclty to the client profile

        //if bracket is used, we only care bracket, not if client or spouse as they are filing jointly
        if(this.incomeInfo.value.incomeBracket){
          updatedClient.clientProfile.Bracket = this.incomeInfo.value.incomeBracket;
        }

        if(this.isClient){
          //update client profile
          //TODO: this needs to be added to the API response obj
          //updatedClient.clientProfile.incomeOption = this.incomeInfo.value.incomeOption;
          //updatedClient.clientProfile.incomeBracket = this.incomeInfo.value.incomeBracket;
                              
        } else {
          //update the spouse proifle (leave client profile alone here)
          //convert to object
          //var selectedClientSpouse = JSON.parse(updatedClient.client.clientProfile.Spouses);
          var spouseOne = this.selectedClientSpouse[0];

          //TODO: set object for spouse
          //TODO: this needs to be added to the API response obj
          //spouseOne.incomeOption = this.incomeInfo.value.incomeOption;
          //spouseOne.incomeBracket = this.incomeInfo.value.incomeBracket;
          
          //convert back to json string
          updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
        }

        this.editedClient = updatedClient;
        this.saveClientV2(updatedClient);
      }
    
    } else if(this.section == 'my-retirement'){
      //validate that sections form; make sure valid
      if(this.retireInfo.valid){
        if(this.isClient){
          //update client profile
          updatedClient.clientProfile.RetirementAge = this.retireInfo.value.retirementAge;
          updatedClient.clientProfile.RetirementState = this.retireInfo.value.retirementState;
          let clientMetroArea = this.profile.clientProfile.ClientMetroArea && this.retireInfo.value.retirementState != 'NA' && this.isClient && this.responseLTCMetroRegions ? this.retireInfo.value.retirementStateMetroArea: "";
          updatedClient.clientProfile.ClientMetroArea = (this.retireInfo.value.retirementState == "NA") ? "" : clientMetroArea;
          // updatedClient.clientProfile.ClientMetroArea = (this.retireInfo.value.retirementState == "NA") ? "" : this.retireInfo.value.retirementStateMetroArea;
          let isPre65 = (Number(this.retireInfo.value.retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profileInfo.value.dob) >= 65)) ? false : true;
          if (!isPre65) {
            updatedClient.clientProfile.IsPrivHealthIns = false;
            updatedClient.clientProfile.CoverageType = null;
          }

        } else {
          //update the spouse proifle (leave client profile alone here)
          //convert to object
          //var selectedClientSpouse = JSON.parse(updatedClient.client.clientProfile.Spouses);
          var spouseOne = this.selectedClientSpouse[0];

          //TODO: set object for spouse
          spouseOne.retirementAge = this.retireInfo.value.retirementAge;
          spouseOne.state = this.retireInfo.value.retirementState;
          let spouseMetroArea = this.profile.clientProfile.SpouseMetroArea && this.retireInfo.value.retirementState != 'NA' && !this.isClient && this.responseLTCMetroRegions ? this.retireInfo.value.retirementStateMetroArea : "";
          // updatedClient.clientProfile.SpouseMetroArea = this.retireInfo.value.retirementStateMetroArea;
          updatedClient.clientProfile.SpouseMetroArea = spouseMetroArea;

          let isSpousePre65 = (Number(this.retireInfo.value.retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profileInfo.value.dob) >= 65)) ? false : true;
          if (!isSpousePre65) {
            updatedClient.clientProfile.IsSpousePrivHealthIns = false;
            updatedClient.clientProfile.SpouseCoverageType = null;
          }


          //convert back to json string
          updatedClient.clientProfile.Spouses = JSON.stringify(this.selectedClientSpouse);
        }
        this.editedClient = updatedClient;
        // this.calculateLifeExp(false, true, this.isSavedBtnClicked);
        this.saveClientV2(updatedClient);
      }
    
    } else if(this.section == 'my-retirement-healthcare'){
      //validate that sections form; make sure valid
      if(this.retirementHealthcare.valid){
        //Update coverage options here for client and spouse
        if(this.isClient){
          let isPre65 = (Number(this.retireInfo.value.retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profileInfo.value.dob) >= 65)) ? false : true;
          if (!isPre65) {
            updatedClient.clientProfile.IsPrivHealthIns = false;
            updatedClient.clientProfile.CoverageType = null;
          }
          updatedClient.clientProfile.IsPrivHealthIns = (this.retirementHealthcare.value.needPrivateInsurance == 'true') ? true : false;
          updatedClient.clientProfile.CoverageType = (this.retirementHealthcare.value.needPrivateInsurance == 'true') ? this.retirementHealthcare.value.coverageType: null;
          updatedClient.clientProfile.PremiumType = this.retirementHealthcare.value.premiumType;

          if(updatedClient.clientProfile.Premiums){
            updatedClient.clientProfile.Premiums = JSON.parse(updatedClient.clientProfile.Premiums);
          }

          if(this.retirementHealthcare.value.premiumType == 'TM'){
            if(this.retirementHealthcare.controls['premMedPartB'].disabled){
              this.retirementHealthcare.controls['premMedPartB'].enable();
              updatedClient.clientProfile.Premiums.MedicarePartB = this.retirementHealthcare.value.premMedPartB;
              this.retirementHealthcare.controls['premMedPartB'].disable();
            } else {
              updatedClient.clientProfile.Premiums.MedicarePartB = this.retirementHealthcare.value.premMedPartB;
            }

            if(this.retirementHealthcare.controls['premMedPartD'].disabled){
              this.retirementHealthcare.controls['premMedPartD'].enable();
              updatedClient.clientProfile.Premiums.MedicarePartD = this.retirementHealthcare.value.premMedPartD;
              this.retirementHealthcare.controls['premMedPartD'].disable();
            } else {
              updatedClient.clientProfile.Premiums.MedicarePartD = this.retirementHealthcare.value.premMedPartD;
            }
            //updatedClient.clientProfile.Premiums.MedicarePartD = this.retirementHealthcare.value.premMedPartD;

            if(this.retirementHealthcare.controls['premSupplemental'].disabled){
              this.retirementHealthcare.controls['premSupplemental'].enable();
              updatedClient.clientProfile.Premiums.SupplimentalInsurance = this.retirementHealthcare.value.premSupplemental;
              this.retirementHealthcare.controls['premSupplemental'].disable();
            } else {
              updatedClient.clientProfile.Premiums.SupplimentalInsurance = this.retirementHealthcare.value.premSupplemental;
            }
            //updatedClient.clientProfile.Premiums.SupplimentalInsurance = this.retirementHealthcare.value.premSupplemental;
          } else if(this.retirementHealthcare.value.premiumType == 'HMO'){
            this.retirementHealthcare.controls['medAdvantageHMO'].enable();
            updatedClient.clientProfile.Premiums.MedicareAdvantageHMO = this.retirementHealthcare.value.medAdvantageHMO || this.retirementHealthcare.value.premiumType == 'HMO';
            this.retirementHealthcare.controls['medAdvantageHMO'].disable();
          } else if(this.retirementHealthcare.value.premiumType == 'PPO'){
            this.retirementHealthcare.controls['medAdvantagePPO'].enable();
            updatedClient.clientProfile.Premiums.MedicareAdvantagePPO = this.retirementHealthcare.value.medAdvantagePPO || this.retirementHealthcare.value.premiumType == 'PPO';
            this.retirementHealthcare.controls['medAdvantagePPO'].disable();
          }

          updatedClient.clientProfile.SelfSupplementalPlan = this.retirementHealthcare.value.premSupplementalPlanType;

          if(this.retirementHealthcare.controls['premDental'].disabled){
            this.retirementHealthcare.controls['premDental'].enable();
            updatedClient.clientProfile.Premiums.DentalInsurance = this.retirementHealthcare.value.premDental;
            this.retirementHealthcare.controls['premDental'].disable();
          } else {
            updatedClient.clientProfile.Premiums.DentalInsurance = this.retirementHealthcare.value.premDental;
          }
          //updatedClient.clientProfile.Premiums = JSON.stringify(updatedClient.clientProfile.Premiums);

          if(updatedClient.clientProfile.OOPCosts){
            updatedClient.clientProfile.OOPCosts = JSON.parse(updatedClient.clientProfile.OOPCosts);
          }


          if(this.retirementHealthcare.controls['oopHospDocsTests'].disabled){
            this.retirementHealthcare.controls['oopHospDocsTests'].enable();
            updatedClient.clientProfile.OOPCosts.HospitalAndTest = this.retirementHealthcare.value.oopHospDocsTests;
            this.retirementHealthcare.controls['oopHospDocsTests'].disable();
          } else {
            updatedClient.clientProfile.OOPCosts.HospitalAndTest = this.retirementHealthcare.value.oopHospDocsTests;
          }

          if(this.retirementHealthcare.controls['oopRXDrugs'].disabled){
            this.retirementHealthcare.controls['oopRXDrugs'].enable();
            updatedClient.clientProfile.OOPCosts.PrescriptionDrugs = this.retirementHealthcare.value.oopRXDrugs;
            this.retirementHealthcare.controls['oopRXDrugs'].disable();
          } else {
            updatedClient.clientProfile.OOPCosts.PrescriptionDrugs = this.retirementHealthcare.value.oopRXDrugs;
          }
          
          if(this.retirementHealthcare.controls['oopHearingVision'].disabled){
            this.retirementHealthcare.controls['oopHearingVision'].enable();
            updatedClient.clientProfile.OOPCosts.HearingAndVisionCosts = this.retirementHealthcare.value.oopHearingVision;
            this.retirementHealthcare.controls['oopHearingVision'].disable();
          } else {
            updatedClient.clientProfile.OOPCosts.HearingAndVisionCosts = this.retirementHealthcare.value.oopHearingVision;
          }

          if(this.retirementHealthcare.controls['oopDental'].disabled){
            this.retirementHealthcare.controls['oopDental'].enable();
            updatedClient.clientProfile.OOPCosts.DentalCosts = this.retirementHealthcare.value.oopDental;
            this.retirementHealthcare.controls['oopDental'].disable();
          } else {
            updatedClient.clientProfile.OOPCosts.DentalCosts = this.retirementHealthcare.value.oopDental;
          }
          //updatedClient.clientProfile.OOPCosts = JSON.stringify(updatedClient.clientProfile.OOPCosts);

          //we need to replay values with Client values if this is true....
          updatedClient.clientProfile.IsHSApplySpouse = this.retirementHealthcare.value.applyToSpouse;
            //&& (updatedClient.clientProfile.SpousePremiumType == updatedClient.clientProfile.PremiumType);

          if(updatedClient.clientProfile.IsHSApplySpouse){
            
            //need to check if spouse is even eligable for pre65, if the Client is
            //convert spouse obj from string to JSON
            updatedClient.clientProfile.Spouses = JSON.parse(updatedClient.clientProfile.Spouses);
            console.log('spouse on save in area', updatedClient.clientProfile.Spouses);
            var isSpousePre65 = (Number(updatedClient.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(updatedClient.clientProfile.Spouses[0].dob)) >= 65) ? false: true;
            if(isSpousePre65){
              updatedClient.clientProfile.IsSpousePrivHealthIns = updatedClient.clientProfile.IsPrivHealthIns;
              updatedClient.clientProfile.SpouseCoverageType = updatedClient.clientProfile.CoverageType;
            } else {
              updatedClient.clientProfile.IsSpousePrivHealthIns = false;
              updatedClient.clientProfile.SpouseCoverageType = null;
            }

            //convert Spouse obj back to string from JSON, as we dont need it anymore
            updatedClient.clientProfile.Spouses = JSON.stringify(updatedClient.clientProfile.Spouses);

            updatedClient.clientProfile.SpousePremiumType = updatedClient.clientProfile.PremiumType;

            updatedClient.clientProfile.SpousePremiums = JSON.parse(updatedClient.clientProfile.SpousePremiums);
            updatedClient.clientProfile.SpouseOOPCosts = JSON.parse(updatedClient.clientProfile.SpouseOOPCosts);
  
            if(this.retirementHealthcare.value.premiumType == 'TM'){
              updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartB = updatedClient.clientProfile.Premiums.MedicarePartB;
              updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartD = updatedClient.clientProfile.Premiums.MedicarePartD;
              updatedClient.clientProfile.SpousePremiums.SpouseSupplimentalInsurance = updatedClient.clientProfile.Premiums.SupplimentalInsurance;
            } else if(this.retirementHealthcare.value.premiumType == 'HMO'){
              updatedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO = (updatedClient.clientProfile.Premiums.MedicareAdvantageHMO) ? updatedClient.clientProfile.Premiums.MedicareAdvantageHMO : false;
            } else if(this.retirementHealthcare.value.premiumType == 'PPO'){
              updatedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO = (updatedClient.clientProfile.Premiums.MedicareAdvantagePPO) ? updatedClient.clientProfile.Premiums.MedicareAdvantagePPO : false;
            }

            updatedClient.clientProfile.SpouseSupplementalPlan = updatedClient.clientProfile.SelfSupplementalPlan;

            updatedClient.clientProfile.SpousePremiums.SpouseDentalInsurance = updatedClient.clientProfile.Premiums.DentalInsurance;
  
            updatedClient.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest = updatedClient.clientProfile.OOPCosts.HospitalAndTest;
            updatedClient.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs = updatedClient.clientProfile.OOPCosts.PrescriptionDrugs;
            updatedClient.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts = updatedClient.clientProfile.OOPCosts.HearingAndVisionCosts;
            updatedClient.clientProfile.SpouseOOPCosts.SpouseDentalCosts = updatedClient.clientProfile.OOPCosts.DentalCosts;

            updatedClient.clientProfile.SpousePremiums = JSON.stringify(updatedClient.clientProfile.SpousePremiums);
            updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);
          }


          updatedClient.clientProfile.Premiums = JSON.stringify(updatedClient.clientProfile.Premiums);
          updatedClient.clientProfile.OOPCosts = JSON.stringify(updatedClient.clientProfile.OOPCosts);

        } else {
                      
          updatedClient.clientProfile.IsSpousePrivHealthIns = (this.retirementHealthcare.value.needPrivateInsurance == 'true') ? true : false;
          let isSpousePre65 = (Number(this.retireInfo.value.retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(this.profileInfo.value.dob) >= 65)) ? false : true;
          if (!isSpousePre65) {
            updatedClient.clientProfile.IsSpousePrivHealthIns = false;
            updatedClient.clientProfile.SpouseCoverageType = null;
          }
          updatedClient.clientProfile.SpouseCoverageType = this.retirementHealthcare.value.coverageType;
          updatedClient.clientProfile.SpousePremiumType = this.retirementHealthcare.value.premiumType;
          updatedClient.clientProfile.SpouseSupplementalPlan = this.retirementHealthcare.value.premSupplementalPlanType;
          console.log('this.retirementHealthcare', this.retirementHealthcare)
          console.log('updatedClient.clientProfile', updatedClient.clientProfile)
          // if(this.retirementHealthcare.value.premiumType == 'TM'){
          //   // updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartB = JSON.stringify(updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartB );
          //   updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartB = this.retirementHealthcare.value.premMedPartB;
          //   updatedClient.clientProfile.SpousePremiums.SpouseMedicarePartD = this.retirementHealthcare.value.premMedPartD;
          //   updatedClient.clientProfile.SpousePremiums.SpouseSupplimentalInsurance = this.retirementHealthcare.value.premSupplemental;
          // } else if(this.retirementHealthcare.value.premiumType == 'HMO'){
          //   updatedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO = this.retirementHealthcare.value.medAdvantageHMO;
          // } else if(this.retirementHealthcare.value.premiumType == 'PPO'){
          //   updatedClient.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO = this.retirementHealthcare.value.medAdvantagePPO;
          // }
          // updatedClient.clientProfile.SpousePremiums.SpouseDentalInsurance = this.retirementHealthcare.value.premDental;
          let spousePremiums;
          if(this.retirementHealthcare.value.premiumType == 'TM'){
            // console.log('this.spouseMedicareCoverageForm.value.SpouseMedicarePartB', this.spouseMedicareCoverageForm.value.SpouseMedicarePartB)
            spousePremiums = {
              "SpouseMedicarePartB": (this.retirementHealthcare.controls['premMedPartB'].disabled) ? true : this.retirementHealthcare.value.premMedPartB,
              "SpouseMedicarePartD": (this.retirementHealthcare.controls['premMedPartD'].disabled) ? true : this.retirementHealthcare.value.premMedPartD,
              "SpouseSupplimentalInsurance": (this.retirementHealthcare.controls['premSupplemental'].disabled) ? true : this.retirementHealthcare.value.premSupplemental,
              "SpouseDentalInsurance": (this.retirementHealthcare.controls['premDental'].disabled) ? true : this.retirementHealthcare.value.premDental
            } 
          } else if(this.retirementHealthcare.value.premiumType == 'HMO'){
            this.retirementHealthcare.controls['medAdvantageHMO'].enable();
            spousePremiums = {
              "SpouseMedicareAdvantageHMO": this.retirementHealthcare.value.medAdvantageHMO,
              "SpouseDentalInsurance": this.retirementHealthcare.value.premDental
            }
            this.retirementHealthcare.controls['medAdvantageHMO'].disable();
          } else if(this.retirementHealthcare.value.premiumType == 'PPO'){
            this.retirementHealthcare.controls['medAdvantagePPO'].enable();
            spousePremiums = { 
              "SpouseMedicareAdvantagePPO": this.retirementHealthcare.value.medAdvantagePPO,
              "SpouseDentalInsurance": this.retirementHealthcare.value.premDental
            }
            this.retirementHealthcare.controls['medAdvantagePPO'].disable();
          }
          updatedClient.clientProfile.SpousePremiums = JSON.stringify(spousePremiums);
          let spouseOOPCosts;
          spouseOOPCosts = {
            "SpouseHospitalAndTest": (this.retirementHealthcare.controls['oopHospDocsTests'].disabled) ? true : this.retirementHealthcare.value.oopHospDocsTests,
            "SpousePrescriptionDrugs": (this.retirementHealthcare.controls['oopRXDrugs'].disabled) ? true : this.retirementHealthcare.value.oopRXDrugs,
            "SpouseHearingAndVisionCosts": (this.retirementHealthcare.controls['oopHearingVision'].disabled) ? true : this.retirementHealthcare.value.oopHearingVision,
            "SpouseDentalCosts": (this.retirementHealthcare.controls['oopDental'].disabled) ? true : this.retirementHealthcare.value.oopDental
          }
          updatedClient.clientProfile.SpouseOOPCosts  = JSON.stringify(spouseOOPCosts);
          //updatedClient.clientProfile.SpousePremiums = JSON.stringify(updatedClient.clientProfile.SpousePremiums);
          // updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);
          // updatedClient.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest = this.retirementHealthcare.value.oopHospDocsTests;
          // updatedClient.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs = this.retirementHealthcare.value.oopRXDrugs;
          // updatedClient.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts = this.retirementHealthcare.value.oopHearingVision;
          // updatedClient.clientProfile.SpouseOOPCosts.SpouseDentalCosts = this.retirementHealthcare.value.oopDental;
          //updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);

          //TODO: i think we need to replay values with Client values if this is true....
          //updatedClient.clientProfile.IsHSApplySpouse = this.retirementHealthcare.value.applyToSpouse;
          /* updatedClient.clientProfile.IsHSApplySpouse = this.retirementHealthcare.value.applyToSpouse 
            && (updatedClient.clientProfile.SpousePremiumType == updatedClient.clientProfile.PremiumType); */

          //if a spouse is updated from the side editor, and the client has 'Apply to Spouse' on - turn off
          //so, by default, if you update the spouse IsHSApplySpouse will always be false then
          updatedClient.clientProfile.IsHSApplySpouse = false;

        }
        this.editedClient = updatedClient;
        //updatedClient.clientProfile.Premiums = JSON.stringify(updatedClient.clientProfile.Premiums);
        //updatedClient.clientProfile.OOPCosts = JSON.stringify(updatedClient.clientProfile.OOPCosts);

        /* if(this.maritalStatusConvert(updatedClient.clientProfile.MaritalStatus) == 'Married'){
          updatedClient.clientProfile.SpousePremiums = JSON.stringify(updatedClient.clientProfile.SpousePremiums);
          updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);
        } */

          console.log('form is validated 071524', updatedClient);
      } else {
        console.log('retirementHealthcare form not valid');
      }

      //move this into each if statement? leave it outside?
      //this.calculateLifeExp(false, false, true);
      this.saveClientV2(updatedClient);
    
    }

    // //this.profile = updatedClient;
    /* updatedClient.clientProfile.Premiums = JSON.stringify(updatedClient.clientProfile.Premiums);
    updatedClient.clientProfile.OOPCosts = JSON.stringify(updatedClient.clientProfile.OOPCosts); */

    /* if(this.maritalStatusConvert(updatedClient.clientProfile.MaritalStatus) == 'Married'){
      updatedClient.clientProfile.SpousePremiums = JSON.stringify(updatedClient.clientProfile.SpousePremiums);
      updatedClient.clientProfile.SpouseOOPCosts = JSON.stringify(updatedClient.clientProfile.SpouseOOPCosts);
    }
    this.editedClient = updatedClient; */

    /* //move this into each if statement? leave it outside?
    this.calculateLifeExp(false, false, true);
    this.saveClientV2(updatedClient); */
  }

  isSavedBtnClicked: boolean = false;
  saveClientV2(client){
    if(this.isSavedBtnClicked){
    //for the section, use this.section
    //for client, use this.profile
    let AdvisorID = localStorage.getItem('selectedAdvisorID');
    let AdvisorOrgID = localStorage.getItem('selectedAdvisorOrgID');


    console.log('this.profile', this.profile)
    localStorage.setItem('clientProfile', JSON.stringify(client.clientProfile));
    client.clientProfile.HCCDYrsDiag = client.clientProfile.HCCDYrsDiag || 0;
    client.clientProfile.HCCYrsDiag = client.clientProfile.HCCYrsDiag || 0;
    if (client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      client.clientProfile.Spouses[0].HCCDYrsDiag =  client.clientProfile.Spouses[0].HCCDYrsDiag || 0;
      client.clientProfile.Spouses[0].HCCYrsDiag = client.clientProfile.Spouses[0].HCCYrsDiag || 0;
    }

    var UserModel = {
      AdvisorID: AdvisorID,
      OrganizationID: AdvisorOrgID,
      ID: this.profile.client ? this.profile.client.ID : 0,
      Username: this.profile.client.email,//this.clientModelV2.generalInformation.email,
      Email: this.profile.client.Email,//this.clientModelV2.generalInformation.email,
      FirstName: this.profile.client.FirstName,//this.clientModelV2.generalInformation.firstName,
      LastName: this.profile.client.LastName,//this.clientModelV2.generalInformation.lastName,
      Address: this.profile.client.Address,//this.clientModelV2.generalInformation.address,
      City: this.profile.client.City,//this.clientModelV2.generalInformation.city,
      State: this.profile.client.State,//this.clientModelV2.generalInformation.state,
      Zip: this.profile.client.Zip,//this.clientModelV2.generalInformation.zip,
      Phone: this.profile.client.Phone,//this.clientModelV2.generalInformation.phone,
      DOB: this.profile.client.DOB,//this.clientModelV2.generalInformation.dobStr,
      GenderID: Number(this.profile.client.GenderID),
    }
    localStorage.setItem('userModel', JSON.stringify(UserModel));

    var RiskTolerance = null;
    console.log('client.clientProfile', client.clientProfile)
    console.log('this.profile', this.profile)
    // client.clientProfie = JSON.parse(client.clientProfie);
    // console.log('this.isPre65',this.isPre65);
    client.clientProfile.Premiums = JSON.parse(client.clientProfile.Premiums);
    client.clientProfile.SpousePremiums = JSON.parse(client.clientProfile.SpousePremiums);
    client.clientProfile.Spouses = JSON.parse(client.clientProfile.Spouses);
    //client.clientProfile.Children = JSON.parse(client.clientProfile.Children);

    // console.log('client.clientProfile.Premiums.MedicarePartB', client.clientProfile.Premiums.MedicarePartB)
    console.log('this.profile.clientProfile.Premiums', this.profile.clientProfile.Premiums)
    // client.clientProfile.Premiums.MedicarePartB = false;
    // this.isPre65 = (Number(client.clientProfile.RetirementAge || 0) >= 65 || Number(this.globalService.calculateAge(client.client.DOB)) >= 65) ? false: true;
    // this.isSpousePre65 = (Number(client.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob)) >= 65) ? false: true;
    // this.isSpousePre65 = ((Number(updatedClient.clientProfile.Spouses[0].retirementAge || 0) >= 65 || Number(this.globalService.calculateAge(updatedClient.clientProfile.Spouses[0].dob)) >= 65) ? false: true);
    // if ((client.clientProfile.Premiums.MedicarePartB || client.clientProfile.Premiums.MedicarePartD || client.clientProfile.Premiums.MedicareAdvantageHMO ||  client.clientProfile.Premiums.MedicareAdvantagePPO) && this.isPre65) {
    //   console.log('here i am')
    //   // let premiums = null;
    //   if(client.clientProfile.PremiumType == 'TM'){
    //     client.clientProfile.Premiums.MedicarePartB = false;
    //     client.clientProfile.Premiums.MedicarePartD = false;
    //     // premiums = {
    //     //   "MedicarePartB": false,
    //     //   "MedicarePartD": false,
    //     //   "SupplimentalInsurance": client.clientProfile.Premiums.SupplimentalInsurance,
    //     //   "DentalInsurance": client.clientProfile.Premiums.DentalInsurance
    //     // }
    //     // console.log('premiumns', premiums)
    //   } else if(client.clientProfile.PremiumType == 'HMO'){
    //     client.clientProfile.Premiums.MedicareAdvantageHMO = false;
    //     // premiums = {
    //     //   "MedicareAdvantageHMO": false,
    //     //   "DentalInsurance": client.clientProfile.Premiums.DentalInsurance
    //     // }
    //   } else if(client.clientProfile.PremiumType == 'PPO'){
    //     client.clientProfile.Premiums.MedicareAdvantagePPO = false;
    //     // premiums = { 
    //     //   "MedicareAdvantagePPO": false,
    //     //   "DentalInsurance": client.clientProfile.Premiums.value.DentalInsurance
    //     // }
    //   }
    //   // client.clientProfile.Premiums = premiums;
    // }
    // if (client.clientProfile.Spouses[0].maritalStatus == 'Married') {
    //   console.log('client.clientProfile.Spouses[0].maritalStatus');
    //   console.log('this.isSpousePre65',this.isSpousePre65);
    //   if ((client.clientProfile.SpousePremiums.SpouseMedicarePartB || client.clientProfile.SpousePremiums.SpouseMedicarePartD || client.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO ||  client.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO) && this.isSpousePre65) {
    //     if(client.clientProfile.SpousePremiumType == 'TM'){
    //       client.clientProfile.SpousePremiums.SpouseMedicarePartB = false;
    //       client.clientProfile.SpousePremiums.SpouseMedicarePartD = false;
    //     } else if(client.clientProfile.SpousePremiumType == 'HMO'){
    //       client.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO = false;
    //     } else if(client.clientProfile.SpousePremiumType == 'PPO'){
    //       client.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO = false;
    //     }
    //   }

    // }
    console.log('got in SAVE:', client);
    console.log('UserModel', UserModel)
    client.clientProfile.Premiums = JSON.stringify(client.clientProfile.Premiums);
    client.clientProfile.SpousePremiums = JSON.stringify(client.clientProfile.SpousePremiums);
    client.clientProfile.Spouses = JSON.stringify(client.clientProfile.Spouses);

    if(client.clientProfile.Children){
      //client.clientProfile.Children = JSON.stringify(client.clientProfile.Children);
      //client.clientProfile.Children = '[]';
    } else {
      //client.clientProfile.Children = '[]';
    }
    
    //only place the variable 'client' gets used is here. We only care about the edited values
    //not updated all the object.
    this.globalService.createClient(UserModel, client.clientProfile, RiskTolerance)
        .subscribe(
          resp => {
            if (resp.type != 0) {
              this.sidebarService.setClientUpdate(true)
              if (!this.profile.clientProfile) {
                this.globalService.getClientsData()
                  .subscribe(
                    clients => {
                      //TODO: maybe keep this?
                      //UserModel.ID = resp.message;
                      //this.snackBarService.add('To create a report for ' + UserModel.FirstName + ' ' + UserModel.LastName + ', please click ', 0, 1, 10000);

                    },
                    error => {
                      //TODO: maybe keep this?
                      //this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                      this.error = <any>error;

                    });
              } else {
                //TODO: maybe keep this?
                //this.snackBarService.add('Client has been updated', 0);
              }
              
              //success
              //this.isSavedBtnClicked = true;
              //when save is successful, call function > this.directBackToTabView(); to go back 
              this.directBackToTabView();

            } else {
              //error
            }

          },
          error => {
            //TODO: maybe keep this?
            //this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
            this.error = <any>error;

          });
        }
  }

  ngOnDestroy() {
    //this.router.onSameUrlNavigation = 'reload';
    //this.router.navigate([this.router.url]);
  }
 
  directBackToTabView(){
    // this.calculateLifeExp(false, true, this.isSavedBtnClicked);    
    this.delete.emit(this.profile);
    this.isSavedBtnClicked = false;
  }

  retirementAgeChange(value) {
    this.selectedRetirementAge = Number(this.retireInfo.value.retirementAge);
  }

  displayLifeExpPopup: boolean = true;
  changeLifeExpPopup() {
    if(this.displayLifeExpPopup){
      const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
        data: { title: 'Notification!', 
        question: "Modifying date of birth resets the client's life expectancy. If you previously selected a different life expectancy, <br/>it will be changed to the default.<br/>Modifying date of birth removes any inputted desired claim ages for the client and their spouse. A new desired claim age can be added.", 
        btnYesTitle: 'I Understand' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          //then allow the LE to be updated
          dialogRef.close();

        } else {
          dialogRef.close();
        }
      });

      this.displayLifeExpPopup = false;
    }
  }

  generateLifeExpectancyDropDownAmount(dob, retirementAge) {
    const age = this.globalService.calculateAgeV2(dob);
    return Math.max(age, retirementAge)
  }
}
